import { createClient } from '@supabase/supabase-js';
import { Database } from '../types/database.types';
import { assertLocalEnvironment } from '../utils/environment/localEnvironment';
import { logger } from '../utils/logging/logger';

// Validate environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('Missing Supabase environment variables:', {
    url: !!supabaseUrl,
    key: !!supabaseKey,
  });
  throw new Error(
    'Application configuration error: Missing Supabase credentials',
  );
}

if (process.env.REACT_APP_DATA_ENV === 'local') {
  assertLocalEnvironment(supabaseUrl, supabaseKey);
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey);
export const adminAuthClient = supabase.auth.admin;

// Initialize logger with Supabase client
if (process.env.NODE_ENV !== 'test') {
  logger.initialize(supabase);
}
